import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Grid,
  CircularProgress,
  Button,
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';

const ConferenceParticipantDashboard = () => {
  const history = useHistory();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/conference-particpant-event`)
      .then(res => {
        if (res.status === 200) {
          setEvents(res.data.events || []);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Fetch error:", err);
        setLoading(false);
      });
  }, []);

  // const handleViewEvent = (eventId, eventName) => {
  //   localStorage.setItem('eventid', eventId);
  //   localStorage.setItem('eventname', eventName);
  //   history.push(`/admin/conference/single-event-dashbord/${eventId}`); // Change this to your route
  // };

  const handleViewEvent = async (eventId, eventName) => {
  localStorage.setItem('eventid', eventId);
  localStorage.setItem('eventname', eventName);

  try {
    const res = await axios.get(`/api/speaker/profile-status/${eventId}`);
   
    if (res.data?.userID?.participant_join_id === 1 && res.data?.userID?.event_id === eventId) {
      localStorage.setItem('loginParticpantID', res.data?.userID?.id);
      history.push(`/admin/conference/speaker-dashbord/${eventId}`);
    } else {
   history.push(`/admin/conference/single-event-dashbord/${eventId}`);
    }
  } catch (error) {
    console.error('Failed to fetch speaker info:', error);
    // fallback route if needed
   history.push(`/admin/conference/single-event-dashbord/${eventId}`);
  }
};


  const logoutSubmit = (e) => {
    e.preventDefault();

    axios.post(`api/logout`).then(res => {
      if (res.data.status === 200) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_name');
        localStorage.removeItem('role');
        localStorage.removeItem('user_id');
        localStorage.removeItem('eventname');
        localStorage.removeItem('eventid');
        localStorage.removeItem('abstractId');

        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: res.data.message,
          showConfirmButton: false,
          timer: 1500
        });

        history.push('/');
      }
    });
  };

  return (
 <Container maxWidth="md" sx={{ mt: 10, py: 3 }}>
  <Typography variant="body1" color="text.secondary" textAlign="center" mb={4}>
    View your registered conferences below.
  </Typography>

  {loading ? (
    <Box display="flex" justifyContent="center">
      <CircularProgress />
    </Box>
  ) : events.length > 0 ? (
    <Grid container spacing={3}>
      {events.map((event, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Card sx={{ 
            borderRadius: 3, 
            boxShadow: 3,
            height: '100%', // Make all cards the same height
            display: 'flex',
            flexDirection: 'column'
          }}>
            <CardContent sx={{ flexGrow: 1 }}> {/* This makes the content fill the card */}
              <Typography variant="h6" gutterBottom>
                {event.eventname || `Event #${event.id}`}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Created At: {new Date(event.created_at).toLocaleDateString()}
              </Typography>
              <Typography variant="body2" color={event.status === 1 ? 'green' : 'red'}>
                Status: {event.status === 1 ? 'Active' : 'Inactive'}
              </Typography>
              <Typography variant="body2" mt={1} sx={{
                display: '-webkit-box',
                overflow: 'hidden',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 3 // Limit to 3 lines and show ellipsis
              }}>
                {event.description || 'No description provided.'}
              </Typography>
            </CardContent>

            <Box sx={{ p: 2 }}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={() => handleViewEvent(event.id, event.eventname)}
              >
                View
              </Button>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  ) : (
    <Typography variant="body2" color="text.secondary" textAlign="center">
      You have no registered events.
    </Typography>
  )}
</Container>
    // <Container maxWidth="md" sx={{ mt: 20 }}>
    //   {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
    //     <Typography variant="h4">Dashboard</Typography>
    //     <Button variant="outlined" color="error" onClick={logoutSubmit}>
    //       Logout
    //     </Button>
    //   </Box> */}

    //   <Typography variant="body1" color="text.secondary" textAlign="center" mb={4}>
    //     View your registered conferences below.
    //   </Typography>

    //   {loading ? (
    //     <Box display="flex" justifyContent="center">
    //       <CircularProgress />
    //     </Box>
    //   ) : events.length > 0 ? (
    //     <Grid container spacing={3}>
    //       {events.map((event, index) => (
    //         <Grid item xs={12} md={6} key={index}>
    //           <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
    //             <CardContent>
    //               <Typography variant="h6" gutterBottom>
    //                 {event.eventname || `Event #${event.id}`}
    //               </Typography>
    //               <Typography variant="body2" color="text.secondary">
    //                 Created At: {new Date(event.created_at).toLocaleDateString()}
    //               </Typography>
    //               <Typography variant="body2" color={event.status === 1 ? 'green' : 'red'}>
    //                 Status: {event.status === 1 ? 'Active' : 'Inactive'}
    //               </Typography>
    //               <Typography variant="body2" mt={1}>
    //                 {event.description || 'No description provided.'}
    //               </Typography>

    //               <Box mt={2}>
    //                 <Button
    //                   variant="contained"
    //                   color="primary"
    //                   fullWidth
    //                   onClick={() => handleViewEvent(event.id, event.eventname)}
    //                 >
    //                   View
    //                 </Button>
    //               </Box>
    //             </CardContent>
    //           </Card>
    //         </Grid>
    //       ))}
    //     </Grid>
    //   ) : (
    //     <Typography variant="body2" color="text.secondary" textAlign="center">
    //       You have no registered events.
    //     </Typography>
    //   )}
    // </Container>
  );
};

export default ConferenceParticipantDashboard;
